import ViewSwitcher from './ViewSwitcher';
import ViewSwitcherContainer from './ViewSwitcher.container';

export default ViewSwitcherContainer(ViewSwitcher);
